export default "/images/add.svg?968645e19ab1b90eb90655ff71dea87f";